import { useLocalSearchParams } from 'expo-router'

import type { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionRewardScreen } from '@/src/features/intention/ui/screens/IntentionRewardScreen'
import type { TSourceParam } from '@/src/general/constants/routes'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

const IntentionRewardTypeRouterPage = () => {
  const { routes } = useRoutes()

  const searchParams = useLocalSearchParams()
  const { idSharetoken, source, redirect, type, prayerId, theme } = filterSearchParams<
    {
      idSharetoken: TIdDashSlug
      type: INTENTION_TYPE
      redirect?: string
      prayerId: `${number}`
      theme?: string
    } & TSourceParam
  >(searchParams)

  if (!idSharetoken || !type) return null

  return (
    <IntentionRewardScreen
      prayerId={Number(prayerId)}
      source={source ?? TRACKING_SOURCE.UNDEFINED}
      idSharetoken={idSharetoken}
      redirect={redirect ?? routes.intentions()}
      theme={theme}
      type={type}
    />
  )
}

export default IntentionRewardTypeRouterPage
